import { render, staticRenderFns } from "./SupervisorValidationTable.vue?vue&type=template&id=04a8a972&scoped=true&"
import script from "./SupervisorValidationTable.vue?vue&type=script&lang=js&"
export * from "./SupervisorValidationTable.vue?vue&type=script&lang=js&"
import style0 from "./SupervisorValidationTable.vue?vue&type=style&index=0&id=04a8a972&lang=scss&scoped=true&"
import style1 from "./SupervisorValidationTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a8a972",
  null
  
)

export default component.exports